import React, { Fragment } from "react"
import { Link } from "gatsby"
import { Box, Flex, Grid } from "theme-ui"
import styled from "@emotion/styled"
import CTAButton from "components/cta-button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import TextWithImage from "components/pages/textWithImage"
import SingleColumn from "components/pages/singleColumn"
import MultiColumn from "components/pages/multiColumn"
import ShareButtonSocial from "components/share-button-social"

const GridContent = styled(Grid)`
    & .contact-button {
        flex-wrap: wrap;
    }
    & .contact-button a {
        border: 1px solid ${(props) => props.theme.colors.secondary};
        background: ${(props) => props.theme.colors.secondary};
        color: ${(props) => props.theme.colors.background};
        margin-top: 0.5rem;
        margin-right: 1rem;
        padding: 0.5rem 1.5rem;
        text-decoration: none;
        font-weight: normal;

        &:hover {
            text-decoration: none;
            background: ${(props) => props.theme.colors.background};
            color: ${(props) => props.theme.colors.secondary};
        }
    }
    & .raw-html-embed {
        padding-bottom: 2rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & .contact-button a {
            padding: 0.5rem 1rem;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        grid-template-columns: 1fr;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        & .contact-button a {
            padding: 0.2rem 0.5rem;
            font-size: 12px;
            margin-right: 0.5rem;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[1]}) {
        & .contact-button a {
            padding: 0.2rem 0.5rem;
            font-size: 11px;
            margin-right: 0.3rem;
        }
    }
`

// markup
const IndexPage = ({ data, location }) => {
    const { pageData, post } = data
    const CTAbutton =
        post.events.length > 0 ? post.events[0].Call_To_Action : []
    const es = CTAbutton.find((x) => x.externalScripts)

    const customJsx = (
        <>
            <h3 className="content-title">{post.title}</h3>
            <GridContent gap={3} columns={[2, "2fr 3fr"]}>
                <Box>
                    <GatsbyImage
                        image={getImage(post.image)}
                        alt={post.title}
                    />
                </Box>
                <Box>
                    <div
                        dangerouslySetInnerHTML={{ __html: post.description }}
                    ></div>
                    <Flex className="contact-button content-paragraph">
                        {CTAbutton
                            ? CTAbutton.map((obj, index) => (
                                  <CTAButton data={obj} key={index} />
                              ))
                            : null}
                        {es ? (
                            <div>
                                <Link
                                    variant="buttonSquare"
                                    href={es.buttonLink}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {es.buttonText}
                                </Link>
                                {es.externalScripts}
                            </div>
                        ) : null}
                    </Flex>
                </Box>
            </GridContent>
        </>
    )

    let pageContent = null

    if (post.content && post.content.length > 0) {
        pageContent = post.content.map((page, index) => {
            let html = null
            if (
                page.Single_Column !== undefined &&
                page.Single_Column !== null
            ) {
                html = (
                    <SingleColumn
                        data={page.Single_Column}
                        key={index}
                        style={{ overflow: "scroll" }}
                    />
                )
            } else if (
                page.Text_With_Image !== undefined &&
                page.Text_With_Image !== null
            ) {
                let doubleText = false
                if (
                    index === 0 &&
                    page.Text_With_Image.Layout_Type !== "Full_Width_Image"
                ) {
                    doubleText = true
                }
                html = (
                    <Fragment key={index}>
                        <TextWithImage
                            data={page.Text_With_Image}
                            description={pageData.description}
                            doubleText={doubleText}
                        />
                    </Fragment>
                )
            } else if (
                page.Multi_Columns !== undefined &&
                page.Multi_Columns !== null
            ) {
                html = <MultiColumn data={page.Multi_Columns} key={index} />
            }
            return html
        })
    }

    return (
        <Fragment style={{ overflowX: "auto" }}>
            {customJsx}
            {pageContent}
            <ShareButtonSocial path={location.pathname} url={location.href} />
        </Fragment>
    )
}

export default IndexPage
